var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "table-responsive" }, [
      _c("table", [
        _c("tbody", [
          _c("tr", [
            _vm._m(1),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.cliente.descripcion))]),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _c("td", [
              _vm._v(_vm._s(_vm.cliente.descripcion_tipo_identificacion))
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _vm._m(3),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.cliente.numero_identificacion))]),
            _vm._v(" "),
            _vm._m(4),
            _vm._v(" "),
            _c("td", [
              _vm.cliente.coordenadas_cliente != null
                ? _c(
                    "button",
                    {
                      staticClass: "btn-info btn--text",
                      attrs: { type: "button" },
                      on: { dblclick: _vm.verDireccionCliente }
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.cliente.direccion) +
                          "\n            "
                      )
                    ]
                  )
                : _c("span", [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.cliente.direccion) +
                        "\n            "
                    )
                  ])
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _vm._m(5),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.cliente.telefonos))]),
            _vm._v(" "),
            _vm._m(6),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.cliente.celulares))])
          ]),
          _vm._v(" "),
          _c("tr", [
            _vm._m(7),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.cliente.correos_electronicos))]),
            _vm._v(" "),
            _vm._m(8),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.cliente.referencia_domicilio))])
          ]),
          _vm._v(" "),
          _c("tr", [
            _vm._m(9),
            _vm._v(" "),
            _c("td", { attrs: { colspan: "3" } }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.cliente.observacion_cliente) +
                  "\n          "
              )
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-buttons" }, [
      _c(
        "button",
        {
          staticClass: "btn-danger btn--text",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.$emit("cerrar")
            }
          }
        },
        [
          _c("i", { staticClass: "fa fa-times" }),
          _c("span", [_vm._v("Cerrar")])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h5", [_vm._v("Información del cliente")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Nombre completo")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Tipo de identificación")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Número de identificación")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Dirección")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Teléfono(s)")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Celular(es)")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Correo(s)")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Referencia de domicilio")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Observación de cliente")])])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a33cef3a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a33cef3a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/InformacionCliente.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-a33cef3a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/InformacionCliente.vue
// module chunks = 0